(function () {
  if (window.__auraButtonReady) return;
  window.__auraButtonReady = true;

  var CX = 140, CY = 40, RX = 132, RY = 42, N = 96, TAU = Math.PI * 2;
  var WAVES = [
    { freq: 2, amp: 0.09, phase: 0.5, speed: 0.85 },
    { freq: 3, amp: 0.07, phase: 1.1, speed: -1.05 },
    { freq: 5, amp: 0.04, phase: 1.9, speed: 1.3 },
    { freq: 8, amp: 0.02, phase: 2.7, speed: -1.5 }
  ];

  function toExactPath(pts, tans) {
    var n = pts.length, sc = TAU / n / 3;
    var d = 'M ' + pts[0][0].toFixed(3) + ' ' + pts[0][1].toFixed(3) + ' ';
    for (var i = 0; i < n; i++) {
      var p1 = pts[i], p2 = pts[(i + 1) % n];
      var t1 = tans[i], t2 = tans[(i + 1) % n];
      d +=
        'C ' + (p1[0] + t1[0] * sc).toFixed(3) + ' ' + (p1[1] + t1[1] * sc).toFixed(3) + ' ' +
        (p2[0] - t2[0] * sc).toFixed(3) + ' ' + (p2[1] - t2[1] * sc).toFixed(3) + ' ' +
        p2[0].toFixed(3) + ' ' + p2[1].toFixed(3) + ' ';
    }
    return d + 'Z';
  }

  function buildBasePath() {
    var pts = [], tans = [];
    for (var i = 0; i < N; i++) {
      var theta = (i / N) * TAU;
      pts.push([CX + RX * Math.cos(theta), CY + RY * Math.sin(theta)]);
      tans.push([-RX * Math.sin(theta), RY * Math.cos(theta)]);
    }
    return toExactPath(pts, tans);
  }
  var BASE_D = buildBasePath();

  function wavePath(t, nx, ny, strength) {
    var angle = Math.atan2(ny, nx);
    var intensity = Math.min(1, Math.sqrt(nx * nx + ny * ny));
    var pts = [], tans = [];
    for (var i = 0; i < N; i++) {
      var theta = (i / N) * TAU;
      var r = 1.0, dr = 0;
      for (var k = 0; k < WAVES.length; k++) {
        var h = WAVES[k];
        var ph = h.freq * theta + h.phase + h.speed * t;
        r += h.amp * Math.sin(ph);
        dr += h.amp * h.freq * Math.cos(ph);
      }
      var wx = CX + RX * r * Math.cos(theta);
      var wy = CY + RY * r * Math.sin(theta);
      var dx = wx - CX, dy = wy - CY;
      var len = Math.sqrt(dx * dx + dy * dy) || 1;
      var raw = (1 - Math.cos(Math.atan2(dy, dx) - angle)) / 2;
      var push = raw * raw * intensity * 7 * strength;
      pts.push([wx + (dx / len) * push, wy + (dy / len) * push]);
      tans.push([
        -RX * r * Math.sin(theta) + RX * dr * Math.cos(theta),
         RY * r * Math.cos(theta) + RY * dr * Math.sin(theta)
      ]);
    }
    return toExactPath(pts, tans);
  }

  // Sine-in-out easing
  function easeSineInOut(x) { return -(Math.cos(Math.PI * x) - 1) / 2; }
  // Elastic-out approximation: simple decaying sine
  function easeElasticOut(x) {
    if (x === 0 || x === 1) return x;
    var p = 0.4;
    return Math.pow(2, -10 * x) * Math.sin((x - p / 4) * (2 * Math.PI) / p) + 1;
  }

  // Breathing phases (sec, target opacity, target width)
  var BREATH = [
    { dur: 3.0, opa: 1, sw: 1.62 },
    { dur: 4.0, opa: 1, sw: 1.24 },
    { dur: 2.5, opa: 1, sw: 1.38 }
  ];
  var BREATH_TOTAL = BREATH.reduce(function (a, b) { return a + b.dur; }, 0);

  function breathAt(t, baseOpa, baseSw) {
    var loop = t % BREATH_TOTAL;
    var acc = 0, prevO = baseOpa, prevS = baseSw;
    for (var i = 0; i < BREATH.length; i++) {
      var ph = BREATH[i];
      if (loop < acc + ph.dur) {
        var lt = (loop - acc) / ph.dur;
        var e = easeSineInOut(lt);
        return { opa: prevO + (ph.opa - prevO) * e, sw: prevS + (ph.sw - prevS) * e };
      }
      acc += ph.dur;
      prevO = ph.opa;
      prevS = ph.sw;
    }
    return { opa: baseOpa, sw: baseSw };
  }

  var filterCounter = 0;

  // ---- frame scheduler ------------------------------------------------------
  // Each aura rebuilds a 96-segment path string every frame and hands it to a
  // feTurbulence + feDisplacementMap filter, so one button repaints its whole
  // bbox 60×/s (12 of them on a collection page). Landing that on the same
  // frames as a scroll starved the compositor — text visibly flickered while
  // scrolling on mobile (2026-09-10). The animation is idle decoration, so it
  // runs only while the button is on screen, the tab is visible and the page is
  // NOT scrolling; paused time is handed back to the instance so the wave
  // resumes where it stopped instead of jumping.
  var loops = [];
  var scrolling = false;
  var scrollIdle = null;

  function syncAll() {
    for (var i = 0; i < loops.length; i++) loops[i].sync();
  }

  window.addEventListener('scroll', function () {
    if (!scrolling) { scrolling = true; syncAll(); }
    clearTimeout(scrollIdle);
    scrollIdle = setTimeout(function () { scrolling = false; syncAll(); }, 160);
  }, { passive: true });
  document.addEventListener('visibilitychange', syncAll);

  // frame(now, resumedAfter): resumedAfter is the ms skipped while paused —
  // add it to every timestamp the instance keeps.
  function makeLoop(el, frame) {
    var rafId = null, pausedAt = 0, resumedAfter = 0, visible = true, forced = false;

    function step(now) {
      if (!document.body.contains(el)) { stop(); return; }
      var skipped = resumedAfter;
      resumedAfter = 0;
      frame(now, skipped);
      rafId = requestAnimationFrame(step);
    }
    function run() {
      if (rafId !== null) return;
      if (pausedAt) { resumedAfter += performance.now() - pausedAt; pausedAt = 0; }
      rafId = requestAnimationFrame(step);
    }
    function stop() {
      if (rafId === null) return;
      cancelAnimationFrame(rafId);
      rafId = null;
      pausedAt = performance.now();
    }

    var api = {
      sync: function () {
        if (forced || (visible && !scrolling && !document.hidden)) run(); else stop();
      },
      // a press must animate to completion even if a scroll just happened
      force: function (on) { forced = on; api.sync(); }
    };
    loops.push(api);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        visible = e[0].isIntersecting;
        api.sync();
      }, { rootMargin: '80px' }).observe(el);
    }
    api.sync();
    return api;
  }

  function initOne(el) {
    if (el.__auraInited) return;
    el.__auraInited = true;

    var path = el.querySelector('.aura-btn__path');
    var flash = el.querySelector('.aura-btn__flash');
    var filter = el.querySelector('.aura-btn__filter');
    if (!path || !flash || !filter) return;

    // Static variant (e.g. the bundle "Bring it home"): same idle wave +
    // breathing + turbulence motion as the hero buttons, but with NO
    // flash-ripple (the duplicate-svg expand) and NO pointer-driven push.
    // Click feedback is a CSS :active press-down only.
    if (el.classList.contains('aura-btn--static')) {
      var fidS = 'aura-f-' + (++filterCounter) + '-' + Math.floor(Math.random() * 1e6).toString(36);
      filter.setAttribute('id', fidS);
      path.setAttribute('filter', 'url(#' + fidS + ')');
      path.setAttribute('d', BASE_D);
      flash.setAttribute('stroke-opacity', '0');

      var reducedS = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedS) {
        path.setAttribute('d', wavePath(0, 0, 0, 0));
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('stroke-opacity', '1');
        return;
      }

      var phaseS = parseFloat(el.getAttribute('data-aura-phase')) || 0;
      var startS = performance.now() - phaseS * 1000;
      makeLoop(el, function (now, resumedAfter) {
        if (resumedAfter) startS += resumedAfter;
        var t = (now - startS) / 1000;
        path.setAttribute('d', wavePath(t, 0, 0, 0));
        var b = breathAt(t, 1, 1.38);
        path.setAttribute('stroke-opacity', '1');
        path.setAttribute('stroke-width', b.sw.toFixed(3));
      });
      return;
    }

    var fid = 'aura-f-' + (++filterCounter) + '-' + Math.floor(Math.random() * 1e6).toString(36);
    filter.setAttribute('id', fid);
    path.setAttribute('filter', 'url(#' + fid + ')');

    path.setAttribute('d', BASE_D);
    flash.setAttribute('d', BASE_D);

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var disabled = el.hasAttribute('disabled') || el.getAttribute('aria-disabled') === 'true';

    var touch = { nx: 0, ny: 0, str: 0 };
    var pressScale = 1;
    var pressStart = 0;
    var pressActive = false;
    var flashStart = 0;
    var flashActive = false;
    var strengthDecayStart = 0;
    var strengthFrom = 0;
    var strengthTo = 0;
    var strengthDur = 0;
    var strengthEasing = null;

    function setStrength(target, dur, easing) {
      strengthFrom = touch.str;
      strengthTo = target;
      strengthDur = dur;
      strengthEasing = easing;
      strengthDecayStart = performance.now();
    }

    // data-aura-phase (seconds) desynchronizes instances — shifts this
    // button's wave clock so side-by-side auras don't move in lockstep
    var phase = parseFloat(el.getAttribute('data-aura-phase')) || 0;
    var start = performance.now() - phase * 1000;

    function tick(now, resumedAfter) {
      if (resumedAfter) {
        // every clock this instance keeps lives on the same performance.now()
        // timeline, so they all shift by the paused span
        start += resumedAfter;
        pressStart += resumedAfter;
        flashStart += resumedAfter;
        strengthDecayStart += resumedAfter;
      }
      var t = (now - start) / 1000;

      // Strength tween
      if (strengthDur > 0) {
        var sp = Math.min(1, (now - strengthDecayStart) / (strengthDur * 1000));
        var se = strengthEasing ? strengthEasing(sp) : sp;
        touch.str = strengthFrom + (strengthTo - strengthFrom) * se;
        if (sp >= 1) strengthDur = 0;
      }

      if (!reduced) {
        path.setAttribute('d', wavePath(t, touch.nx, touch.ny, touch.str));
      }

      if (!disabled) {
        var b = breathAt(t, 1, 1.38);
        path.setAttribute('stroke-opacity', '1');
        path.setAttribute('stroke-width', b.sw.toFixed(3));
      }

      // Press squash
      if (pressActive) {
        var pt = (now - pressStart) / 1000;
        if (pt < 0.12) {
          var p1 = pt / 0.12;
          pressScale = 1 + (0.94 - 1) * easeSineInOut(p1);
        } else if (pt < 0.12 + 0.75) {
          var p2 = (pt - 0.12) / 0.75;
          pressScale = 0.94 + (1 - 0.94) * easeElasticOut(p2);
        } else {
          pressScale = 1;
          pressActive = false;
        }
        el.style.transform = 'scale(' + pressScale.toFixed(4) + ')';
      }

      // Flash expand
      if (flashActive) {
        var ft = (now - flashStart) / 1000 - 0.04;
        if (ft < 0) {
          flash.setAttribute('stroke-opacity', '1');
          flash.setAttribute('transform', 'scale(1)');
        } else if (ft < 0.60) {
          var fp = ft / 0.60;
          var fe = 1 - Math.pow(1 - fp, 2); // power2.out
          var sc = 1 + (1.22 - 1) * fe;
          var op = 1 - fe;
          flash.setAttribute('stroke-opacity', op.toFixed(3));
          flash.setAttribute('transform', 'translate(140 40) scale(' + sc.toFixed(4) + ') translate(-140 -40)');
        } else {
          flash.setAttribute('stroke-opacity', '0');
          flashActive = false;
        }
      }

    }
    var loop = makeLoop(el, tick);

    function getNorm(cx, cy) {
      var r = el.getBoundingClientRect();
      return {
        nx: ((cx - r.left) / r.width - 0.5) * 2,
        ny: ((cy - r.top) / r.height - 0.5) * 2
      };
    }

    el.addEventListener('pointerdown', function (e) {
      if (disabled) return;
      var n = getNorm(e.clientX, e.clientY);
      touch.nx = n.nx;
      touch.ny = n.ny;
      setStrength(0.55, 0.14, function (x) { return 1 - Math.pow(1 - x, 2); });
      setTimeout(function () { setStrength(0, 1.3, easeElasticOut); }, 180);
      pressActive = true;
      pressStart = performance.now();
      flashActive = true;
      flashStart = performance.now();
      // press squash 0.87s + flash 0.64s — hold the loop open past both
      loop.force(true);
      setTimeout(function () { loop.force(false); }, 1000);
    }, { passive: true });

    el.addEventListener('touchstart', function (e) {
      var t0 = e.touches[0];
      if (!t0) return;
      var n = getNorm(t0.clientX, t0.clientY);
      touch.nx = n.nx;
      touch.ny = n.ny;
      setStrength(1, 0.18, function (x) { return 1 - Math.pow(1 - x, 2); });
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      var t0 = e.touches[0];
      if (!t0) return;
      var n = getNorm(t0.clientX, t0.clientY);
      touch.nx = n.nx;
      touch.ny = n.ny;
    }, { passive: true });

    function touchEnd() {
      setStrength(0, 1.2, easeElasticOut);
    }
    el.addEventListener('touchend', touchEnd, { passive: true });
    el.addEventListener('touchcancel', touchEnd, { passive: true });
  }

  function initAll(root) {
    var nodes = (root || document).querySelectorAll('[data-aura-btn]');
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType === 1) {
          if (node.matches && node.matches('[data-aura-btn]')) initOne(node);
          if (node.querySelectorAll) {
            var sub = node.querySelectorAll('[data-aura-btn]');
            for (var k = 0; k < sub.length; k++) initOne(sub[k]);
          }
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
